import { render, staticRenderFns } from "./LoanPayments.vue?vue&type=template&id=1fbe8bd4&scoped=true"
import script from "./LoanPayments.vue?vue&type=script&lang=js"
export * from "./LoanPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbe8bd4",
  null
  
)

export default component.exports